import { Text } from '@thefarmersfront/kitchen';

import type { CustomHeaderGroupProps } from 'ag-grid-react';

import styles from './../CustomHeaders.module.scss';

/**
 * [정산관리][보관비 조회] 일자 별 보관비 상세 모달 > 헤더 그룹 children 컴포넌트
 */
const StorageDetailCustomHeaderChildren = (props: CustomHeaderGroupProps) => {
  return (
    <Text
      className={`${styles['width-100']} ${styles['ellipsis']}`}
      size="large"
      weight="semi-bold"
      color="tertiary"
      align="center"
    >
      {props.displayName}
    </Text>
  );
};

export default StorageDetailCustomHeaderChildren;
